package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets16 {
  internal val _5_devarim_01_txt: AssetResource by lazy { init__5_devarim_01_txt() }

  internal val _5_devarim_02_txt: AssetResource by lazy { init__5_devarim_02_txt() }

  internal val _5_devarim_03_txt: AssetResource by lazy { init__5_devarim_03_txt() }

  internal val _5_devarim_04_txt: AssetResource by lazy { init__5_devarim_04_txt() }

  internal val _5_devarim_05_txt: AssetResource by lazy { init__5_devarim_05_txt() }

  internal val _5_devarim_06_txt: AssetResource by lazy { init__5_devarim_06_txt() }

  internal val _5_devarim_07_txt: AssetResource by lazy { init__5_devarim_07_txt() }

  internal val _5_devarim_08_txt: AssetResource by lazy { init__5_devarim_08_txt() }

  internal val _5_devarim_09_txt: AssetResource by lazy { init__5_devarim_09_txt() }

  internal val _5_devarim_10_txt: AssetResource by lazy { init__5_devarim_10_txt() }

  internal val _5_devarim_11_txt: AssetResource by lazy { init__5_devarim_11_txt() }

  internal val _5_devarim_12_txt: AssetResource by lazy { init__5_devarim_12_txt() }

  internal val _5_devarim_13_txt: AssetResource by lazy { init__5_devarim_13_txt() }

  internal val _5_devarim_14_txt: AssetResource by lazy { init__5_devarim_14_txt() }

  internal val _5_devarim_15_txt: AssetResource by lazy { init__5_devarim_15_txt() }

  internal val _5_devarim_16_txt: AssetResource by lazy { init__5_devarim_16_txt() }

  internal val _5_devarim_17_txt: AssetResource by lazy { init__5_devarim_17_txt() }

  internal val _5_devarim_18_txt: AssetResource by lazy { init__5_devarim_18_txt() }

  internal val _5_devarim_19_txt: AssetResource by lazy { init__5_devarim_19_txt() }

  internal val _5_devarim_20_txt: AssetResource by lazy { init__5_devarim_20_txt() }

  internal val _5_devarim_21_txt: AssetResource by lazy { init__5_devarim_21_txt() }

  internal val _5_devarim_22_txt: AssetResource by lazy { init__5_devarim_22_txt() }

  internal val _5_devarim_23_txt: AssetResource by lazy { init__5_devarim_23_txt() }

  internal val _5_devarim_24_txt: AssetResource by lazy { init__5_devarim_24_txt() }

  internal val _5_devarim_25_txt: AssetResource by lazy { init__5_devarim_25_txt() }

  internal val _5_devarim_26_txt: AssetResource by lazy { init__5_devarim_26_txt() }

  internal val _5_devarim_27_txt: AssetResource by lazy { init__5_devarim_27_txt() }

  internal val _5_devarim_28_txt: AssetResource by lazy { init__5_devarim_28_txt() }

  internal val _5_devarim_29_txt: AssetResource by lazy { init__5_devarim_29_txt() }

  internal val _5_devarim_30_txt: AssetResource by lazy { init__5_devarim_30_txt() }

  internal val _5_devarim_31_txt: AssetResource by lazy { init__5_devarim_31_txt() }

  internal val _5_devarim_32_txt: AssetResource by lazy { init__5_devarim_32_txt() }

  internal val _5_devarim_33_txt: AssetResource by lazy { init__5_devarim_33_txt() }

  internal val _5_devarim_34_txt: AssetResource by lazy { init__5_devarim_34_txt() }

  internal val _6_yehoshua_01_txt: AssetResource by lazy { init__6_yehoshua_01_txt() }

  internal val _6_yehoshua_02_txt: AssetResource by lazy { init__6_yehoshua_02_txt() }

  internal val _6_yehoshua_03_txt: AssetResource by lazy { init__6_yehoshua_03_txt() }

  internal val _6_yehoshua_04_txt: AssetResource by lazy { init__6_yehoshua_04_txt() }

  internal val _6_yehoshua_05_txt: AssetResource by lazy { init__6_yehoshua_05_txt() }

  internal val _6_yehoshua_06_txt: AssetResource by lazy { init__6_yehoshua_06_txt() }

  internal val _6_yehoshua_07_txt: AssetResource by lazy { init__6_yehoshua_07_txt() }

  internal val _6_yehoshua_08_txt: AssetResource by lazy { init__6_yehoshua_08_txt() }

  internal val _6_yehoshua_09_txt: AssetResource by lazy { init__6_yehoshua_09_txt() }

  internal val _6_yehoshua_10_txt: AssetResource by lazy { init__6_yehoshua_10_txt() }

  internal val _6_yehoshua_11_txt: AssetResource by lazy { init__6_yehoshua_11_txt() }

  internal val _6_yehoshua_12_txt: AssetResource by lazy { init__6_yehoshua_12_txt() }

  internal val _6_yehoshua_13_txt: AssetResource by lazy { init__6_yehoshua_13_txt() }

  internal val _6_yehoshua_14_txt: AssetResource by lazy { init__6_yehoshua_14_txt() }

  internal val _6_yehoshua_15_txt: AssetResource by lazy { init__6_yehoshua_15_txt() }

  internal val _6_yehoshua_16_txt: AssetResource by lazy { init__6_yehoshua_16_txt() }

  internal fun values(): List<AssetResource> = listOf(_5_devarim_01_txt, _5_devarim_02_txt,
      _5_devarim_03_txt, _5_devarim_04_txt, _5_devarim_05_txt, _5_devarim_06_txt, _5_devarim_07_txt,
      _5_devarim_08_txt, _5_devarim_09_txt, _5_devarim_10_txt, _5_devarim_11_txt, _5_devarim_12_txt,
      _5_devarim_13_txt, _5_devarim_14_txt, _5_devarim_15_txt, _5_devarim_16_txt, _5_devarim_17_txt,
      _5_devarim_18_txt, _5_devarim_19_txt, _5_devarim_20_txt, _5_devarim_21_txt, _5_devarim_22_txt,
      _5_devarim_23_txt, _5_devarim_24_txt, _5_devarim_25_txt, _5_devarim_26_txt, _5_devarim_27_txt,
      _5_devarim_28_txt, _5_devarim_29_txt, _5_devarim_30_txt, _5_devarim_31_txt, _5_devarim_32_txt,
      _5_devarim_33_txt, _5_devarim_34_txt, _6_yehoshua_01_txt, _6_yehoshua_02_txt,
      _6_yehoshua_03_txt, _6_yehoshua_04_txt, _6_yehoshua_05_txt, _6_yehoshua_06_txt,
      _6_yehoshua_07_txt, _6_yehoshua_08_txt, _6_yehoshua_09_txt, _6_yehoshua_10_txt,
      _6_yehoshua_11_txt, _6_yehoshua_12_txt, _6_yehoshua_13_txt, _6_yehoshua_14_txt,
      _6_yehoshua_15_txt, _6_yehoshua_16_txt)
}

private fun init__5_devarim_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-01.txt\")") as String, rawPath =
    "allChapters/_5_devarim-01.txt")

private fun init__5_devarim_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-02.txt\")") as String, rawPath =
    "allChapters/_5_devarim-02.txt")

private fun init__5_devarim_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-03.txt\")") as String, rawPath =
    "allChapters/_5_devarim-03.txt")

private fun init__5_devarim_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-04.txt\")") as String, rawPath =
    "allChapters/_5_devarim-04.txt")

private fun init__5_devarim_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-05.txt\")") as String, rawPath =
    "allChapters/_5_devarim-05.txt")

private fun init__5_devarim_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-06.txt\")") as String, rawPath =
    "allChapters/_5_devarim-06.txt")

private fun init__5_devarim_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-07.txt\")") as String, rawPath =
    "allChapters/_5_devarim-07.txt")

private fun init__5_devarim_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-08.txt\")") as String, rawPath =
    "allChapters/_5_devarim-08.txt")

private fun init__5_devarim_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-09.txt\")") as String, rawPath =
    "allChapters/_5_devarim-09.txt")

private fun init__5_devarim_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-10.txt\")") as String, rawPath =
    "allChapters/_5_devarim-10.txt")

private fun init__5_devarim_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-11.txt\")") as String, rawPath =
    "allChapters/_5_devarim-11.txt")

private fun init__5_devarim_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-12.txt\")") as String, rawPath =
    "allChapters/_5_devarim-12.txt")

private fun init__5_devarim_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-13.txt\")") as String, rawPath =
    "allChapters/_5_devarim-13.txt")

private fun init__5_devarim_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-14.txt\")") as String, rawPath =
    "allChapters/_5_devarim-14.txt")

private fun init__5_devarim_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-15.txt\")") as String, rawPath =
    "allChapters/_5_devarim-15.txt")

private fun init__5_devarim_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-16.txt\")") as String, rawPath =
    "allChapters/_5_devarim-16.txt")

private fun init__5_devarim_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-17.txt\")") as String, rawPath =
    "allChapters/_5_devarim-17.txt")

private fun init__5_devarim_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-18.txt\")") as String, rawPath =
    "allChapters/_5_devarim-18.txt")

private fun init__5_devarim_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-19.txt\")") as String, rawPath =
    "allChapters/_5_devarim-19.txt")

private fun init__5_devarim_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-20.txt\")") as String, rawPath =
    "allChapters/_5_devarim-20.txt")

private fun init__5_devarim_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-21.txt\")") as String, rawPath =
    "allChapters/_5_devarim-21.txt")

private fun init__5_devarim_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-22.txt\")") as String, rawPath =
    "allChapters/_5_devarim-22.txt")

private fun init__5_devarim_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-23.txt\")") as String, rawPath =
    "allChapters/_5_devarim-23.txt")

private fun init__5_devarim_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-24.txt\")") as String, rawPath =
    "allChapters/_5_devarim-24.txt")

private fun init__5_devarim_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-25.txt\")") as String, rawPath =
    "allChapters/_5_devarim-25.txt")

private fun init__5_devarim_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-26.txt\")") as String, rawPath =
    "allChapters/_5_devarim-26.txt")

private fun init__5_devarim_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-27.txt\")") as String, rawPath =
    "allChapters/_5_devarim-27.txt")

private fun init__5_devarim_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-28.txt\")") as String, rawPath =
    "allChapters/_5_devarim-28.txt")

private fun init__5_devarim_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-29.txt\")") as String, rawPath =
    "allChapters/_5_devarim-29.txt")

private fun init__5_devarim_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-30.txt\")") as String, rawPath =
    "allChapters/_5_devarim-30.txt")

private fun init__5_devarim_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-31.txt\")") as String, rawPath =
    "allChapters/_5_devarim-31.txt")

private fun init__5_devarim_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-32.txt\")") as String, rawPath =
    "allChapters/_5_devarim-32.txt")

private fun init__5_devarim_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-33.txt\")") as String, rawPath =
    "allChapters/_5_devarim-33.txt")

private fun init__5_devarim_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_5_devarim-34.txt\")") as String, rawPath =
    "allChapters/_5_devarim-34.txt")

private fun init__6_yehoshua_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-01.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-01.txt")

private fun init__6_yehoshua_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-02.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-02.txt")

private fun init__6_yehoshua_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-03.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-03.txt")

private fun init__6_yehoshua_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-04.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-04.txt")

private fun init__6_yehoshua_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-05.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-05.txt")

private fun init__6_yehoshua_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-06.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-06.txt")

private fun init__6_yehoshua_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-07.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-07.txt")

private fun init__6_yehoshua_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-08.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-08.txt")

private fun init__6_yehoshua_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-09.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-09.txt")

private fun init__6_yehoshua_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-10.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-10.txt")

private fun init__6_yehoshua_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-11.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-11.txt")

private fun init__6_yehoshua_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-12.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-12.txt")

private fun init__6_yehoshua_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-13.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-13.txt")

private fun init__6_yehoshua_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-14.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-14.txt")

private fun init__6_yehoshua_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-15.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-15.txt")

private fun init__6_yehoshua_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_6_yehoshua-16.txt\")") as String, rawPath =
    "allChapters/_6_yehoshua-16.txt")

public actual val SharedRes.assets.allChapters._5_devarim_01_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_01_txt

public actual val SharedRes.assets.allChapters._5_devarim_02_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_02_txt

public actual val SharedRes.assets.allChapters._5_devarim_03_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_03_txt

public actual val SharedRes.assets.allChapters._5_devarim_04_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_04_txt

public actual val SharedRes.assets.allChapters._5_devarim_05_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_05_txt

public actual val SharedRes.assets.allChapters._5_devarim_06_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_06_txt

public actual val SharedRes.assets.allChapters._5_devarim_07_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_07_txt

public actual val SharedRes.assets.allChapters._5_devarim_08_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_08_txt

public actual val SharedRes.assets.allChapters._5_devarim_09_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_09_txt

public actual val SharedRes.assets.allChapters._5_devarim_10_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_10_txt

public actual val SharedRes.assets.allChapters._5_devarim_11_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_11_txt

public actual val SharedRes.assets.allChapters._5_devarim_12_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_12_txt

public actual val SharedRes.assets.allChapters._5_devarim_13_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_13_txt

public actual val SharedRes.assets.allChapters._5_devarim_14_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_14_txt

public actual val SharedRes.assets.allChapters._5_devarim_15_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_15_txt

public actual val SharedRes.assets.allChapters._5_devarim_16_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_16_txt

public actual val SharedRes.assets.allChapters._5_devarim_17_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_17_txt

public actual val SharedRes.assets.allChapters._5_devarim_18_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_18_txt

public actual val SharedRes.assets.allChapters._5_devarim_19_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_19_txt

public actual val SharedRes.assets.allChapters._5_devarim_20_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_20_txt

public actual val SharedRes.assets.allChapters._5_devarim_21_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_21_txt

public actual val SharedRes.assets.allChapters._5_devarim_22_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_22_txt

public actual val SharedRes.assets.allChapters._5_devarim_23_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_23_txt

public actual val SharedRes.assets.allChapters._5_devarim_24_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_24_txt

public actual val SharedRes.assets.allChapters._5_devarim_25_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_25_txt

public actual val SharedRes.assets.allChapters._5_devarim_26_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_26_txt

public actual val SharedRes.assets.allChapters._5_devarim_27_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_27_txt

public actual val SharedRes.assets.allChapters._5_devarim_28_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_28_txt

public actual val SharedRes.assets.allChapters._5_devarim_29_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_29_txt

public actual val SharedRes.assets.allChapters._5_devarim_30_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_30_txt

public actual val SharedRes.assets.allChapters._5_devarim_31_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_31_txt

public actual val SharedRes.assets.allChapters._5_devarim_32_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_32_txt

public actual val SharedRes.assets.allChapters._5_devarim_33_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_33_txt

public actual val SharedRes.assets.allChapters._5_devarim_34_txt: AssetResource
  get() = CommonMainAssets16._5_devarim_34_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_01_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_01_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_02_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_02_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_03_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_03_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_04_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_04_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_05_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_05_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_06_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_06_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_07_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_07_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_08_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_08_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_09_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_09_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_10_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_10_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_11_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_11_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_12_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_12_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_13_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_13_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_14_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_14_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_15_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_15_txt

public actual val SharedRes.assets.allChapters._6_yehoshua_16_txt: AssetResource
  get() = CommonMainAssets16._6_yehoshua_16_txt
